<template>
    <div class="page-sign-up">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center">
                    <h1>100% gratis, så længe du har lyst</h1>

                    <p>
                        Med OP'N kan du finde de svar, du har brug for til at drive forretning i en digital tid.
                        Prøv det nye online værktøj allerede i dag og se, hvor smart OP'N egentlig er. Det er gratis.
                    </p>
                </div>
            </div>
        </div>

        <!-- Pricing tables -->

        <div class="sign-up">
            <div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-6 col-md-8 col-sm-10">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-lg" placeholder="Din e-mail" v-model="email" :class="{'is-invalid': emailError}" @keydown.enter="create">
                            </div>

                            <div class="form-group">
                                <input type="text" class="form-control form-control-lg" placeholder="Din hjemmeside" v-model="domain" :class="{'is-invalid': domainError}" @keydown.enter="create">
                            </div>

                            <div class="form-group">
                                <button type="button" class="btn btn-primary btn-lg btn-block try-now lead-trigger" @click="create">
                                    Start gratis nu
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
   @import '~bootstrap/scss/bootstrap.scss';

    .page-sign-up {
        padding-top: 15vh;

        h1 {
            margin-bottom: 20px;

            @include media-breakpoint-down(md) {
                font-size: 30px;
            }
        }

        p {
            max-width: 50vw;
            font-weight: 200;
            font-size: 18px;
            margin: 0 auto;

            @include media-breakpoint-down(md) {
                max-width: 90vw;
            }
        }

        .sign-up {
            position: relative;
            width: 100%;
            padding: 10vh 0;

            &:before {
                position: absolute;
                content: " ";
                background-color: #f7f7fb!important;
                z-index: 1;
                width: 100%;
                height: 30%;
                top: 70%;
                left: 0;
            }

            &:after {
                position: absolute;
                content: " ";
                background: url('/static/images/curve.svg');
                z-index: 1;
                width: 100%;
                height: 200px;
                background-size: cover;
                top: calc(70% - 200px);
                left: 0;
            }

            div {
                position: relative;
                z-index: 2;

                input, button {
                    padding: 15px 20px;
                    font-size: 14px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.08), 0 2px 20px rgba(0,0,0,0.08);

                    &.is-invalid {
                        border-width: 1px;
                    }
                }
            }
        }
    }
</style>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
                email: null,
                domain: null,
                emailError: false,
                domainError: false
            }
        },

        computed: mapGetters({
            source: 'getSource'
        }),

        methods: {
            create() {
                this.emailError = (this.email === null)
                this.domainError = (this.domain === null)

                if (!this.email || !this.domain) {
                    return
                }

                let url = 'https://app.opnx.dk/sign-up?'

                url += 'email=' + encodeURIComponent(this.email) + '&'

                if (this.source) {
                    url += 'utm_source=' + encodeURIComponent(this.source) + '&'
                }

                url += 'domain=' + encodeURIComponent(this.domain)

                window.location.href = url
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/SignUp.vue